export default __webpack_public_path__ + "static/media/hes_so_logo_master.1f45d3ad.png";